import * as firebase from 'firebase'

firebase.initializeApp({
  apiKey: 'AIzaSyDLH24hiofjepdsCrvk50iFC4uMR55xWdM',
  authDomain: 'degeneratebaker-com.firebaseapp.com',
  databaseURL: 'https://degeneratebaker-com.firebaseio.com',
  projectId: 'degeneratebaker-com',
  storageBucket: 'degeneratebaker-com.appspot.com',
  messagingSenderId: '469423956167',
  appId: '1:469423956167:web:287e6bd1676f6a71'
})

const database = firebase.firestore()
const storage = firebase.storage()

export default {
  database() {
    return database
  },
  storage() {
    return storage
  }
}
